export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'I was terrified of shoulder rehabilitation. All those phases and criteria looked impossible. After day 5 with 360° I could structure my first complete protocol without help. By week 3 I was coaching athletes through full return-to-press with confidence. This system is a complete game-changer.',
    name: 'Marcus T.',
    location: 'New York · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/80848e14-15f4-430a-9b92-68ab90c6b61e.jpg',
  },
  {
    quote:
      'I managed knee injuries for 2 years frustrated because my clients kept re-injuring. I tried online courses for 6 months with no real framework. The 360° method actually works. I am now in the professional community coaching 15 clients through safe progressions.',
    name: 'Sofia L.',
    location: 'Toronto · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/362d210d-32c8-42e9-94ff-bc4f4952fd79.jpg',
  },
  {
    quote:
      "I was afraid I was not “good enough” to manage complex injuries. 360° proved me wrong. The visual method makes everything so clear. I felt confident from DAY ONE, which kept me motivated. I recommend it to every trainer and therapist I know.",
    name: 'David P.',
    location: 'Melbourne · Australia',
    flag: '🇦🇺',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/47b0264e-cbb6-45c9-bff8-6a1a4a2fd195.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'The tracking sheets live on my desk now. I assess clients on Monday and I already know which exercises to assign before they leave. I manage 8 injured athletes confidently now.',
    name: 'James R.',
    location: 'Toronto · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7403b0e6-4b72-48c1-9192-410f031e00ab.jpg',
  },
  {
    quote:
      'The Spine & Core Shield did it in three days. I had tried YouTube protocols for six months and always felt lost. Seeing the assessment criteria explained visually finally made clinical sense.',
    name: 'Emma T.',
    location: 'London · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/81425cb1-d010-4002-b9db-3ff420402612.jpg',
  },
  {
    quote:
      'The 6-volume calendar is what kept me consistent. 30 minutes a day learning one protocol, no guessing what to study. Week 4 I returned my first athlete to heavy lifting safely.',
    name: 'Luis M.',
    location: 'California · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/880ec9f6-323a-450b-80d1-71b8a76c1a33.jpg',
  },
  {
    quote:
      'I bought it for the shoulder protocols and stayed for the professional community. The Discord has elite therapists who review your case planning. Worth far more than $27.',
    name: 'Rachel P.',
    location: 'Auckland · New Zealand',
    flag: '🇳🇿',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/fe614a6f-eaed-43fd-ab74-bd42110ca59c.jpg',
  },
];
